import {OverrideFieldName, PlaybookIssue} from "common/types/issue";
import {IssuesetId} from "common/types/issueset";
import {ProjectIssueOverrideTag} from "common/types/project";

export const getIssueFieldValue = (
  issue: PlaybookIssue,
  fieldName: OverrideFieldName,
  issuesetId: IssuesetId,
  tagList: ProjectIssueOverrideTag[],
  concatenate = false,
): string | null => {
  if (!issue?.override_tag_values?.[issuesetId]) {
    return null;
  }

  const issuesetOverrides = issue.override_tag_values[issuesetId];

  const orderedTags = tagList
    .sort((a, b) => a.order - b.order)
    .map(tag => tag.id);
  if (concatenate) {
    const validValues = orderedTags
      .map(tagId => ({
        value: issuesetOverrides[tagId]?.fields?.[fieldName],
        tagName: tagList.find(tag => tag.id === tagId)?.name,
      }))
      .filter(item => item.value);

    if (!validValues.length) {
      return null;
    }

    if (validValues.length === 1) {
      return validValues[0].value;
    }
    return validValues.map(item => `${item.value}`).join("\n");
  }

  for (const tagId of orderedTags) {
    const override = issuesetOverrides[tagId]?.fields?.[fieldName];
    if (override?.length) {
      return override;
    }
  }

  return null;
};
